<template>
    <ModalSide
        class="edit-modal"
        ref="modal"
        :size="'555px'"
        @open="is_show_bg = true"
        @close="is_show_bg = false"
    >
        <div class="email-setting" v-if="!is_set_email_content">
            <header>
                Email Customization Settings
                <svg-icon name="close" @click.native="close"/>
            </header>

            <div class="item-box"
                v-for="(v, k) in handle_data[1].section_groups.filter(e => { return e.tip === 'application' })">
                <div class="small-t">System template</div>
                <div class="tit">
                    {{ v.name }}
                    <svg-icon name="pen" @click="gotoEditEmail(v.index)"/>
                </div>
                <div class="swith-box">
                    Auto-reply email
                    <Switch :checked="v.is_switch" @click.native="v.is_switch = v.is_switch ? false : true; $emit('updateData', handle_data);"/>
                </div>

                <div class="desc" v-if="checkScIndex(v) == -1">{{ v.desc }}</div>

                <div class="need-sch-box" v-else>
                    <div class="text-sch-box">
                        <Checkbox size="small" @click.native="v.group_setting[checkScIndex(v)].client_view.val = 'immediately'; $emit('updateData', handle_data);" :label_text="'Send an immediate email reply upon application approval'" :checked="v.group_setting[checkScIndex(v)].client_view.val === 'immediately'"/>
                        <Checkbox size="small"  @click.native="v.group_setting[checkScIndex(v)].client_view.val = 'scheduled'; $emit('updateData', handle_data);" :label_text="'Schedule an auto-response email to all approved applicants'" :checked="v.group_setting[checkScIndex(v)].client_view.val === 'scheduled'"/>
                    </div>
                
                    <div class="date-time-pick-box"
                        v-if="v.group_setting[checkScIndex(v)].client_view.val === 'scheduled' && checkTimeIndex(v) !== -1">
                        <div class="desc">Applicant will receive it at the following time(UTC):</div>
                        <DateTimePicker
                            :key="v.group_setting[checkTimeIndex(v)].client_view.val" 
                            :date="v.group_setting[checkTimeIndex(v)].client_view.date"
                            :time="v.group_setting[checkTimeIndex(v)].client_view.time"
                            :datetime="v.group_setting[checkTimeIndex(v)].client_view.val"
                            :format="v.group_setting[checkTimeIndex(v)].client_view.plac" @update-date="calendarChange"
                            @update-time="timeChange" :spec_val="v.group_setting[checkTimeIndex(v)].client_view.name"
                            :min_date="min_date" :index="v.index"/>
                    </div>
                </div>
            </div>
        </div>

        <!-- Set-send-email -->
        <div class="set-send-email" v-else>
            <header>
                {{ handle_data[1].section_groups[edit_index].header }}<span>&nbsp;(No reply)</span>
            </header>

            <Scrollbar class="set-email-scroll">
                <Form :schema="schema" :values="values" v-slot="{ errors, success }" @submit="submit" @get-err="getErr" ref="form" :class="[{'is-error': is_error}]">
                    <label>Subject:<span class="red">*</span></label>
                    <Field :type="'text'"
                        :k="subject_value.label"
                        :placeholder="subject_value.client_view.plac"
                        :had_value="subject_value.client_view.val? subject_value.client_view.val : subject_value.client_view.plac"
                        :error_msg="errors[subject_value.label]"
                        :is_success="success[subject_value.label]"
                        @update="update" :ref="(el) => { els.push(el) }"/>

                    <div class="label-box">
                        <label>Content:<span class="red">*</span></label>
                        <div class="link" @click="goPlac">Placeholder guide<svg-icon name="go-out"/></div>
                    </div>
                    
                    <Field :type="'textarea'"
                        :k="content_value.label"
                        :placeholder="content_value.client_view.plac"
                        :had_value="content_value.client_view.val?content_value.client_view.val:content_value.client_view.plac"
                        :error_msg="errors[content_value.label]"
                        :is_success="success[content_value.label]"
                        @update="update" :ref="(el) => { els.push(el) }"
                        :max_value="100000" />
                </Form>
                <div class="bottom-box">
                    <div class="link" @click="senaAEmail">Send me a test ({{ $store.state.user_data.email }})</div>
                    <div class="btn-box">
                        <Button type="button" :border_r="6" color="white" size="32" @click="close">Cancel</Button>
                        <Button type="button" :border_r="6" color="dark-blue" size="32" @click="handleSubmit">Save & apply</Button>
                    </div>
                </div>
            </Scrollbar>
        </div>
    </ModalSide>
    <Transition name="fade">
        <div class="ui-modal-bg" v-if="is_show_bg"></div>
    </Transition>
</template>

<script>
import ModalSide from '@/components/ui/ModalSide.vue';
import Field from '@/components/ui/Field.vue';
import Form from '@/components/ui/Form.vue';
import Button from '@/components/ui/Button.vue';
import Modal from '@/components/ui/Modal.vue';
import Switch from '@/components/ui/Switch.vue';
import Checkbox from '@/components/ui/Checkbox.vue';
import DateTimePicker from '@/components/ui/DateTimePicker.vue';
import { checkScIndex,checkTimeIndex,HandleErrFunction } from '@/utils/ProgramsData.js';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import * as yup from 'yup';
import { Tippy } from 'vue-tippy';
import moment from 'moment';

export default {
    name: 'edit-modal',
    emits: ['calendarChange','timeChange','updateData'],

    components: {
        ModalSide,
        Field,
        Button,
        Form,
        Modal,
        Tippy,
        Switch,
        Checkbox,
        DateTimePicker,
        Scrollbar,
    },

    props: {
        handle_data:{
            type:Array,
            default:[]
        },
        ambassador_application_id: {
            type: Number,
            required: true,
        },
        ambassador_application_name: {
            type: String,
            default: '',
        }
    },

    data() {
        return {
            is_set_email_content: false,
            is_show_bg: false,
            edit_index:0,
            schema: yup.object().shape({
                subject:yup.string().required('Cannot leave blank.'),
                content:yup.string().required('Cannot leave blank.'),
            }),
            els:[],
            values: {
                subject:'',
                content:'',
            },
            errors: {},
            success: {},
            is_error:false,
            min_date: moment.utc().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss')
        }
    },

    computed: {
        brand_name() {
            return this.$store.state.user_data.merchant_account.merchant_display_name;
        },

        subject_value(){
            let copy = JSON.parse(JSON.stringify(this.handle_data[1].section_groups[this.edit_index].group_setting[0])); 

            copy.label = 'subject';
            return copy;
        },

        content_value(){

            let copy = JSON.parse(JSON.stringify(this.handle_data[1].section_groups[this.edit_index].group_setting[1])); 
            
            copy.label='content';
            return copy;
        }

    },

    methods: {
        checkScIndex:checkScIndex,
        checkTimeIndex:checkTimeIndex,

        calendarChange(obj){
            this.$emit('calendarChange', obj);
        },

        timeChange(obj){
            this.$emit('timeChange', obj);
        },

        gotoEditEmail(k, is_open_directly = false){
            if (is_open_directly) {
                this.$refs.modal.open();
            }
            // console.log('gotoEditEmail', k)
            this.edit_index = k;
            this.is_set_email_content = true;
            this.values.subject = this.subject_value.client_view.val?this.subject_value.client_view.val:this.subject_value.client_view.plac;
            this.values.content = this.content_value.client_view.val?this.content_value.client_view.val:this.content_value.client_view.plac;
        },

        update(obj){
            this.is_error = false;
            Object.keys(this.values).forEach(key => {
                if (key === obj.key) this.values[key] = obj.val;
            });
            //errors
            Object.keys(this.values).forEach(key => {
                if (key === obj.key) this.errors[key] = '';
            });
        },

        handleSubmit(){
            this.$refs.form.submit();
        },

        submit(){
            this.handle_data[1].section_groups[this.edit_index].group_setting[0].client_view.val = this.values.subject;
            this.handle_data[1].section_groups[this.edit_index].group_setting[1].client_view.val = this.values.content;
            this.is_set_email_content = false;
            this.$emit('emailSave', this.handle_data);
            this.close();
        },

        getErr(val){
            this.errors=val;
        },

        async open(v) {
            this.$refs.modal.open();
            this.is_set_email_content=false;
            this.gotoEditEmail(v.index);
        },

        close() {
            this.$refs.modal.close();
        },

        senaAEmail(){
            const email = this.$store.state.user_data.email;

            if(!this.is_show_bg){
                this.values.subject = this.subject_value.client_view.val?this.subject_value.client_view.val:this.subject_value.client_view.plac;
                this.values.content = this.content_value.client_view.val?this.content_value.client_view.val:this.content_value.client_view.plac;
                
            }
            let sub=this.values.subject?this.values.subject:this.handle_data[1].section_groups[this.edit_index].group_setting[0].client_view.plac;
            let cot=this.values.content?this.values.content:this.handle_data[1].section_groups[this.edit_index].group_setting[1].client_view.plac;
            
            this.$store.state.is_loading=true;
            this.$ajax(`/ambassador/send-test-email`, {
                method: 'post',
                data:{
                    subject:sub,
                    content:cot,
                    ambassador_application_id:this.ambassador_application_id,
                    ambassador_application_name:this.ambassador_application_name,
                    merchant_account_id:this.$store.state.user_data.merchant_account.id,
                },
            }).then(res => {
                this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Send success!`);
                this.$store.state.is_loading=false;
            }).catch(err=>{
                HandleErrFunction(err,this);
            }); 
        },

        goPlac(){
            window.open('https://exclusive-arithmetic-6e0.notion.site/Conditional-Email-Template-Placeholders-for-Customization-1cc9fc0d03f44735bdd973f55e87e4b6 ', '_blank');
        },

    },

}
</script>
<style lang="scss">
@mixin flexCenter() {
    display: flex;
    align-items: center;
}

.ui-modal-bg {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 990;
    background-color: rgba(0, 0, 0, 0.5);
}

.edit-modal {
    // 面板宽度由 ModalSide 的 size（555px，即内容宽度）控制，
    // 这里只需放开 .ui-side-modal 的 min-width: 600px 限制
    &.ui-side-modal {
        min-width: unset;
    }

    .ui-modal-side--container{
        padding: 24px !important;
        overflow: hidden;
    }

    header{
        font: var(--font-demi-24);
        @include flexCenter();
        justify-content: space-between;
        margin-bottom: 16px;
        width: 100%;
        .svg-icon{
            width: 16px;
            height: 16px;
            cursor: pointer;
        }

        span{
            color:var(--black-50);
            margin-left:4px;
        }
    }

    .email-setting{
        .item-box{
            border-top: solid 1px var(--black-20);
            padding: 12px 0;

            .small-t{
                font: var(--font-med-12);
                color: var(--black-50);
            }

            .tit{
                font: var(--font-med-16);
                color: var(--black-90);
                @include flexCenter();
                justify-content: space-between;
                margin: 6px 0;

                .svg-icon{
                    width: 16px;
                    height: 16px;
                    cursor: pointer;
                }
            }

            .swith-box{
                font: var(--font-med-14);
                color: var(--black-75);
                @include flexCenter();
                justify-content: space-between;
                margin: 6px 0;
            }

            .desc{
                font-size: 12px;
                margin-top: 4px;
            }

            .text-sch-box{
                .ui-checkbox{
                    margin: 2px;
                    color: var(--dark-blue);
                    font: var(--font-med-12);
                }
            }

            .date-time-pick-box{
                .pick-date-box{
                    margin-top: 4px;
                }
                .pick-date-box .mx-datepicker{
                    width:100% !important;
                }
            }
        }
    }

    .set-send-email{

        header{
            justify-content: flex-start;
        }

        label{
            font:var(--font-med-16);

            .red{
                color: var(--red);
            }
        }

        .err-msg-box{
            justify-content: flex-start;
            text-align: left;

            i{
                display: none;
            }
        }

        .ui-input{
            margin: 8px 0 16px;
        }

        textarea{
            height:514px;
        }

        form{
            width: 100%;
        }

        .set-email-scroll{
            height: 90vh;
            display: flex;
            flex-wrap: wrap;
            align-content:space-between;
        }

        .label-box{
            @include flexCenter();
            justify-content: space-between;

            .link{
                font-size:14px;
                color:var(--blue);
                @include flexCenter();
                cursor: pointer;

                .svg-icon{
                    width: 14px;
                    height: 14px;
                }
            }
        }

        .bottom-box{
            @include flexCenter();
            justify-content: space-between;
            width: 100%;

            .link {
                font:var(--font-med-12);
                color:var(--blue);
                cursor: pointer;
            }

            .ui-button.color-dark-blue {
                margin-left: 16px;
            }
        }
    }
}
</style>
